// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"c36d6e2d","651":"a6f2f1b3"}[chunkId] + ".chunk.js";
};